import React, { useEffect, useRef, useState } from 'react'
import { components, useServices } from 'cng-web-lib'
import RelatedBoMListCardDetailComponent from './RelatedBoMListCardDetailComponent'
import CircularProgress from '@material-ui/core/CircularProgress'
import TradeManagementTranslationText from 'src/views/trademanagement/shared/TradeManagementTranslationText'

const initialValues = Object.freeze({})

const FormBody = ({ searchCriteria, ...props }) => {
  const [hasMore, setHasMore] = useState(false)
  const [loading, setLoading] = useState(false)
  const [displayedRelatedBoMCompList, setDisplayedRelatedBoMCompList] =
    useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const loadAmount = 10
  const observer = useRef()



  // @purpose: To find, are there more pages of data to fetch and set page number & parcels
  useEffect(() => {
    setLoading(false)
    const temp = [...props.displayedRelatedBoMCompList]
    if (temp.length < loadAmount) {
      setHasMore(false)
    } else {
      setHasMore(true)
    }
    setPageNumber(0)

    setDisplayedRelatedBoMCompList(temp.flat())
  }, [props.displayedRelatedBoMCompList])



  return (
    <>
      <div className='summary-list-items--container'>
        {displayedRelatedBoMCompList.map((product, idx) => (
          <div key={idx}>
            <RelatedBoMListCardDetailComponent.FormBody
              product={product}
              {...props}
            />
          </div>
        ))}
      </div>
    </>
  )
}

const RelatedBoMListCardComponent = Object.freeze({
  FormBody: FormBody,
  initialValues: initialValues
})

export default RelatedBoMListCardComponent
